import './main-content-spinner.scss';

export function MainContentSpinner() {
  return <div className="payflow-presentation main-content-spinner" />;
}
